<template>
  <div class="explore explore-main bg-grey-background-subdued">
    <div class="partner-home-page">
      <h2 class="text-h2 mb-4">Exclusive partner offers for you</h2>
      <p class="text-caption text-grey-text-subdued mb-16">Sittercity may receive a small commission for your purchase</p>
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-24 justify-items-stretch">
        <div v-for="key in displayKeys" :key="key" class="flex">
          <BHPartnerCard
            variant="small"
            :partner-key="key"
            :header-image-url="ALL_PARENT_PARTNER_CARDS[key].headerImage"
            :title="ALL_PARENT_PARTNER_CARDS[key].title"
            :details-url="ALL_PARENT_PARTNER_CARDS[key].detailsUrl"
            :first-line-text="`by ${ALL_PARENT_PARTNER_CARDS[key].companyName}`"
            :second-line-text="secondLineText(ALL_PARENT_PARTNER_CARDS[key].ages)"
            :observer="observer"
            open-in-new-window
            tall-header
            @cta-clicked="ctaClicked(key)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import BHPartnerCard from '@/components/bh_partners/BHPartnerCard.vue';
import partners from '@/lib/partners';
import partnersData from '@/lib/partners.data';

export default {
  name: 'PartnersHomePage',
  components: {
    BHPartnerCard,
  },
  data(): any {
    return {
      ALL_PARENT_PARTNER_CARDS: partnersData.ALL_PARENT_PARTNER_CARDS(),
      displayKeys: [],
      observer: null as any,
    };
  },
  computed: {
    account() {
      return this.$store.getters['account/getAccount'];
    },
    zipCode() {
      return this.$store.getters['account/getZipCode'];
    },
  },
  created() {
    this.displayKeys = partners.getPartners(Object.keys(this.ALL_PARENT_PARTNER_CARDS).length, this.zipCode);
    this.observer = new IntersectionObserver(this.onElementObserved, {
      root: this.$el,
      threshold: 0.5,
    });
  },
  beforeUnmount() {
    this.observer.disconnect();
  },
  methods: {
    onElementObserved(entries) {
      entries.forEach(({ target, isIntersecting }) => {
        if (!isIntersecting) {
          return;
        }

        this.observer.unobserve(target);
        const key = target.getAttribute('id');
        partners.sendPartnerSegmentEvent('Partner Impression', key);
      });
    },
    secondLineText(ageRange) {
      if (ageRange) {
        if (ageRange === 'All ages') return ageRange;
        return `Ages ${ageRange}`;
      }
      return null;
    },
    ctaClicked(key) {
      partners.partnerClicked(key);
    },
  },
};
</script>
